<template>
  <div id="faces-matched">
    <!-- <input type="checkbox" v-model="all" v-on:change="updateResults"/>&nbsp;<label>All?</label>&nbsp;<label>{{loading ? "Loading..." : ""}}</label> -->
    <div class="input-boxes-area">
      <input type="radio" id="radio_all" value="all" v-model="which_results" v-on:change="updateResults">
      <label for="radio_all">All</label>
      <br>
      <input type="radio" id="radio_matched" value="matched" v-model="which_results" v-on:change="updateResults">
      <label for="radio_all">Matched</label>
      <br>
      <input type="radio" id="radio_notmatched" value="notmatched" v-model="which_results" v-on:change="updateResults">
      <label for="radio_all">Not Matched</label>
      <br>
    </div>
    <virtual-list :size="200" :remain="10">
      <div class="row" v-for="(match, row_number) of face_matches" :key="match.runtime_face_uuid">
        <div class="rownum">
          #{{row_number}}
        </div>
        <div class="text-data">
          <div class="camera-description">
            {{match.camera_description}}
          </div>
          <div class="captured-at">
            {{getTimeString(match.captured_at)}}
          </div>  
        </div>
        <div class="image-area">
          <!-- <img :src="'http://node-runner.p.owal.io:9612/faceimage/' + match.runtime_face_uuid" height='160dp'/> -->
          <img :src="'https://yakov.owal.io/api/v6/faces/images/' + match.runtime_face_uuid + '?shape=1&clahe=1'" height='160dp'/>
          <!-- <img :src="BASE_URL + '/api/v4/faceimage/' + match.runtime_face_uuid" height='160dp'/> -->
        </div>
        <div class="results-area">
          <img :src="imageUriForFrontendFaceUUID(match.frontend_face_uuid)" />
          <div class="name-area">
            <div id="circle" v-bind:style="{background: colorForMatchConfidence(match.match_confidence)}" />&nbsp;{{confidenceformat(match.match_confidence)}}&nbsp;
            <router-link v-bind:to="'/faces/' + personNameForUUID(match.frontend_face_uuid)" class="potential-match-name">{{personNameForUUID(match.frontend_face_uuid)}}</router-link>
          </div>
        </div>
        <div class="row-button-area" v-if="typeof not_match_filter[match.runtime_face_uuid] === 'undefined'">
          <div v-if="match.match_confidence">
            <input type="button" value="Wrong match?" v-on:click="startFindingMatchForRuntimeFaceUUID(match.runtime_face_uuid)"/>
          </div>
          <div v-else>
            <input type="button" value="Enter match"  v-on:click="startFindingMatchForRuntimeFaceUUID(match.runtime_face_uuid)"/>
          </div>
          <router-link v-bind:to="'/matchingtags/' + match.runtime_face_uuid">Why?</router-link>
        </div>
      </div>
    </virtual-list>
  </div>
</template>

<script>

// import InfiniteLoading from 'vue-infinite-loading';
import virtualList from 'vue-virtual-scroll-list'

import {BASE_URL} from '../api/base';
import {mapGetters} from 'vuex';
import {facesmatched} from '../api/faces';
import moment from 'moment';
import momenttz from 'moment-timezone';
import {confidenceformat, colorForMatchConfidence} from '../util/confidence';

export default {
  name: 'faces-matched',
  data: function() {
    return {
      faces: [],
      face_matches: [],
      searching: true,
      BASE_URL,
      new_results: 0,
      not_match_filter: {},
      batch_number: 0,
      loading: false,
      loadingMore: false,
      oldest_time: '',
      refresh_token: '',
      which_results: 'matched',
    }
  },
  computed: mapGetters(['frontendFaces', 'isLoggedIn']),
  created() {
    this.updateResults()
  },
  methods: {
    colorForMatchConfidence, confidenceformat,
    getTimeDiff(time_str) {
      console.log(time_str);
      return moment.utc(time_str).fromNow();
    },
    getTimeString(time_str) {
      return moment.utc(time_str).tz('America/New_York').format("dddd, MMMM Do YYYY, h:mm:ss a");
    },
    updateResults() {
      console.log(`Loading all results with which_results=${this.which_results}!...`)
      this.loading = true;
      facesmatched(this.which_results).then(res => res.data).then((res) => {
        this.loading = false;
        this.face_matches = res.faces_matched
      }).catch((err) => {console.error(err)})
    },
    imageUriForFrontendFaceUUID(frontend_face_uuid) {
      const face = this.frontendFaces.find(x => x.frontend_face_uuid == frontend_face_uuid);
      if (!face) {
        console.log(`frontend face not found: ${frontend_face_uuid}`);
        return '';
      }
      if (!face.images || !face.images.length) {
        console.log(`frontend face has no images: ${frontend_face_uuid}`);
        return '';
      }
      return face.images[0].thumbnail_uri;
    },
    personNameForUUID(frontend_face_uuid) {
      if (!frontend_face_uuid) return '';
      const face = this.frontendFaces.find(x => x.frontend_face_uuid == frontend_face_uuid);
      if (!face) {
        console.log(`frontend face not found: ${frontend_face_uuid}`);
        return '';
      }
      return face.person_name;
    },
    startFindingMatchForRuntimeFaceUUID(runtime_face_uuid) {
      this.$set(this.not_match_filter, runtime_face_uuid, '')
    }
  },
  components: {
    // InfiniteLoading,
    'virtual-list': virtualList
  },
}
</script>

<style scoped>

.row {
  display: flex;
  flex-direction: row;
}

#circle {
  width: 10px;
  height: 10px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  background: red;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// FacesMatched.vue?215188f5